var swiper = new Swiper(".page-header__slider .mySwiper", {
    slidesPerView: 2,
    spaceBetween: 15,
    autoHeight: true,
    navigation: {
        nextEl: ".page-header__slider .swiper-button-next",
        prevEl: ".page-header__slider .swiper-button-prev",
    },
    breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1440: {
            slidesPerView: 5,
            spaceBetween: 15,
        },
      },
});